import { NMP } from '@ipreo/nmp-types';
import { normalizeUrl } from './normalize-url';

export interface ModuleResponse {
  privateBaseURL: string;
  privateBaseURLs: string[];
  manifest: NMP.ModuleManifest;
  manifests: NMP.ModuleManifest[];
}

export class Registry {
  public url: string;

  constructor(url: string) {
    this.url = normalizeUrl(url);
  }

  public authenticate(authToken: string): Promise<null | Error> {
    const request = new XMLHttpRequest();
    request.open('POST', `${this.url}api/authenticate`, true);
    request.setRequestHeader('Content-type', 'text/plain');
    request.withCredentials = true;

    return new Promise((resolve, reject) => {
      request.onreadystatechange = () => {
        if (request.readyState === 4) {
          switch (request.status) {
            case 200:
              resolve(null);
              break;
            default:
              reject(new Error(`Authorization failed: ${request.statusText}`));
              break;
          }
        }
      };
      request.send(authToken);
    });
  }

  public fetchModule(name: string, version: string): Promise<ModuleResponse> {
    return fetch(
      `${this.url}api/manifest/${encodeURIComponent(name)}/${version}`
    )
      .then(this.checkStatus.bind(this))
      .then(this.parseJSON.bind(this));
  }

  public fetchModules(
    moduleArray: { name: string; version: string }[]
  ): Promise<ModuleResponse> {
    const modules: string = moduleArray
      .map((moduleDef) => {
        return `${encodeURIComponent(moduleDef.name + '@')}${
          moduleDef.version
        }`;
      })
      .join(',');

    return fetch(`${this.url}api/manifests?modules=${modules}`)
      .then(this.checkStatus.bind(this))
      .then(this.parseJSON.bind(this));
  }

  private checkStatus(response: Response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      throw new Error(response.statusText);
    }
  }

  // eslint:disable-next-line:@typescript-eslint/no-explicit-any
  private parseJSON(response: Response): Promise<any> {
    return response.json();
  }
}
